module.exports = __webpack_public_path__ + "img/Sahashra.9094e9c6.png";